module.exports = __webpack_public_path__ + "static/media/test.7ba64959.jpg";